import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Cancel } from "@mui/icons-material";
import { setLoading } from "../App";

export default function PaymentFailure() {
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 pt-20 pb-4 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md w-full text-center">
        {/* Status Icon */}
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <Cancel style={{ width: 48, height: 48, color: "#dc2626" }} />
          </div>
        </div>

        {/* Status Message */}
        <h2 className="text-3xl font-bold mb-2">
          <span className="text-red-600">Payment Failed</span>
        </h2>

        <p className="text-gray-600 mb-8">
          There was an issue processing your payment. Please try again later.
        </p>

        {/* Action Button */}
        <div className="space-y-3">
          <button
            onClick={() => navigate("/")}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Go to Home
          </button>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Powered by ShurjoPay • Secure Payment Gateway
          </p>
        </div>
      </div>
    </div>
  );
}
